import {
	getGetProjectNetworkStatsQueryOptions,
	getListProjectWorkStatusUpdatesQueryOptions,
} from '@amarantos/api-client'
import { createFileRoute } from '@tanstack/react-router'
import { RouteErrorFallback } from '@/components/route-error-fallback'
import { ProjectNetworkStats } from '@/features/networks'
import { ProjectWorkStatusUpdatesReport } from '@/features/work-status-updates/components/project-work-status-updates-report'
import {
	getWorkStatusScopeStatuses,
	toListWorkStatusUpdatesParams,
	workStatusUpdatesSearchSchema,
} from '@/features/work-status-updates/utils/search'

export const Route = createFileRoute('/_authenticated/projects/$projectId/reports')({
	validateSearch: workStatusUpdatesSearchSchema,
	loaderDeps: ({ search }) => search,
	loader: ({ context: { queryClient }, params: { projectId }, deps }) => {
		queryClient.ensureQueryData(getGetProjectNetworkStatsQueryOptions(projectId))
		queryClient.ensureQueryData(
			getListProjectWorkStatusUpdatesQueryOptions(
				toListWorkStatusUpdatesParams(projectId, deps.page, getWorkStatusScopeStatuses(deps.scope)),
			),
		)
	},
	errorComponent: ({ error, reset }) => (
		<RouteErrorFallback error={error} reset={reset} fallbackMessageKey='error.load_work_status_updates' />
	),
	component: ProjectReportsRoute,
})

function ProjectReportsRoute() {
	const search = Route.useSearch()
	const { projectId } = Route.useParams()
	const navigate = Route.useNavigate()

	return (
		<div className='space-y-6'>
			<ProjectNetworkStats projectId={projectId} />
			<ProjectWorkStatusUpdatesReport
				projectId={projectId}
				scope={search.scope}
				page={search.page}
				onPageChange={(page) => navigate({ search: (previous) => ({ ...previous, page }) })}
			/>
		</div>
	)
}
